import axios from 'axios';
import React from 'react'
import QrReader from 'react-qr-reader'
import {useHistory} from 'react-router-dom'

export default function QrScanner() {
    const history = useHistory();
    const API_PATH = process.env.REACT_APP_API_PATH
    function errorH(e)
    {
        console.log(e);
    }
    function resH(e)
    {
        if(e !== null)
        {
            let raw = e.split('-');
            if(raw[0] === "KIREIPETIR")
            {
                console.log(raw[1]);
                checkUnique(raw[1]);
            }
            else {
                alert("Wrong Format");
                console.log(e);
            }
        }
    }
    const checkUnique = (id) => 
    {
        console.log("Checking ",id);
        axios.get(API_PATH + `/unique?id=${id}`)
        .then((response)=>{
            // let data = response.data
            history.push(`/newmember?id=${id}`)
        })
        .catch((err)=>{
            console.log(err.response.data);
            alert(err.response.data.values)
        })
    }
    return (
        <div>
        <h1>Scan QR</h1>
        <QrReader
            delay={300}
             onError={(err)=> errorH(err)}
             onScan={(res)=> resH(res)}
            style={{ width: '100%' }}
        />

        </div>
    )
}
